/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />

module Meevo.Plugins.Paging {
    "use strict";

    export class PagingContext extends Meevo.Components.CommonClasses.CommonContextBase {

        public sectionsSecurityKeysBase: Array<string> = [
            this.securityKeys.INTEGRATION_PAGING_TAB_MAIN
        ];

        public loadingInProgress: boolean;

        constructor(
            appSettings: Meevo.Components.Common.IAppSettings,
            dataService: Meevo.Components.CommonClasses.ICommonDataService,
            modalService: Meevo.Components.Modal.IModalService,
            identityService: Meevo.Components.Common.IIdentityService,
            loggingService: Meevo.Components.Logging.ILoggingService,
            securityChecker: Meevo.Components.Common.ISecurityService,
            trackingService: Meevo.Components.Tracking.ITrackingService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected pagingService: Meevo.Plugins.Paging.PagingService
        ) {
            super(appSettings,
                dataService,
                modalService,
                identityService,
                loggingService,
                securityChecker,
                trackingService);

            this.baseEndpoint = appSettings.API_ENDPOINTS.paging;
            this.sectionTemplatePath = "app/plugins/paging/sectionViews/";

            this.initializeSections();
        }

        initializeSections(): void {
            let baseSectionProps: ISectionParamsPaging = {
                sectionId: 0,
                displayNameContentKey: "",
                template: "",
                isPrimarySection: false,
                handlesOwnCrud: true,
                baseEndpoint: this.baseEndpoint,
                sectionEndpoint: "",
                loggingService: this.loggingService,
                dataService: this.dataService,
                pagingService: this.pagingService,
                context: this,
                identityService: this.identityService,
                busyService: this.busyService,
                noun: Meevo.Model.NounEnum.Egift,
                sectionSecurityKey: ""
            }
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.INTEGRATION_PAGING_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(new MainSection(_.extend({}, baseSectionProps,
                    {
                        displayNameContentKey: "SECTION_MAIN",
                        template: "main.html",
                        isPrimarySection: true,
                        sectionSecurityKey: this.securityKeys.INTEGRATION_PAGING_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ
                    })));
            }

            this.activate();
        }

        initializeHeader(model: any): void {
            if (this.selectedSection instanceof MainSection) {
                let selectedSection = <MainSection>this.selectedSection;

             /*   selectedSection.modelMerchantAccountIdBackup = selectedSection.model.settings.paymentProcessingPreferences;
                selectedSection.getMerchantAccounts(selectedSection.model.settings.locationId);*/
            }
        }

        protected buildCrudSecurityKeysBase(baseKey, hasCreateKey = false, hasCopyKey = false) {
            this.editSecurityKey = baseKey + Meevo.Components.Common.SecurityParts.KEY_PART_WRITE;

        }

        selectSection(item): void {
            super.selectSection(item);

            this.buildCrudSecurityKeysBase(this.sectionsSecurityKeysBase[item.sectionId]);

            if (item.getData && _.isFunction(item.getData)) {
                item.getData();
            }
        }

        showEditLogic(): boolean {
            return this.isReadonly;
        }

        canEditLogic(): boolean {
            if (this.securityChecker
                .hasSecurityDenyOrGrant(this.sectionsSecurityKeysBase[this.selectedSection.sectionId] +
                Meevo.Components.Common.SecurityParts.KEY_PART_WRITE)) {
                return true;
            }

            return super.canEditLogic();
        }

        canSaveLogic(): boolean {
            return this.isEditing;
        }

        canCancelLogic(): boolean {
            return this.isEditing;
        }

        save(): angular.IPromise<any> {
            if ([0].indexOf(this.selectedSection.sectionId) !== -1 && this.canSave) {
                return super.customSave();
            }

            return super.save();
        }

    }
}
